import React from 'react';
import pt from 'prop-types';
import loadingGif from './images/45.svg';
import PrimaryButton from './buttons/PrimaryButton';
import SecondaryButton from './buttons/SecondaryButton';
import Message from './message/Message';
import {ButtonWrap, Disclaimer} from './MarketoForm.styles';
import styled from 'styled-components';
import {getLocale} from '@epic-core/common';

const Loading = styled.div`
    background-image: url(${p => p.src});
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    height: 70px;
    width: 70px;
    margin: 0 auto;
`;

const MarketoButtonToolbar = ({
    loading, pristine, success, formValid, reset, submitted, status, successBtnLabel, resetBtnLabel,
    successMsg, failureMsg, submissionDisclaimer, loadingImg, loadingNode, errors = [], errorCode}) => {
    const sanitizedErrorCode = errorCode && errorCode.replace(/['"]+/g, '');
    let failMsg = failureMsg || <Message code="com.epicgames.marketo.submit.failure" />;
    if (submitted && !success && status && status === 404) {
        failMsg = <Message code="com.epicgames.marketo.submit.failure.404" />
    } else if (submitted && !success && status && status === 400) {
		if (sanitizedErrorCode === 'errors.com.epicgames.validation.resubmit') {
			failMsg = <Message code="errors.com.epicgames.validation.resubmit" />
		} else {
			failMsg = <Message code="com.epicgames.marketo.submit.failure.400" />
		}
    }

    const submitDisabled = loading || pristine || success || !formValid;
    const resetDisabled = loading || pristine;

    return (
        <ButtonWrap className="button-wrap">

            {submissionDisclaimer ? <Disclaimer>{submissionDisclaimer}</Disclaimer> : ''}

            <PrimaryButton label="Submit" disabled={submitDisabled} as="button" className={`mkt-btn mkt-pri-btn ${submitDisabled ? 'disabled' : ''}`}>
                {successBtnLabel || <Message code="com.epicgames.marketo.submit" />}
                {success ? <i className="icon-checkmark" /> : ''}
            </PrimaryButton>
            <SecondaryButton onClick={(e) => {
                    reset(e);
                }}
                disabled={resetDisabled}
                className={`mkt-btn mkt-sec-btn ${resetDisabled ? 'disabled' : ''}`}>
                {resetBtnLabel || <Message code="com.epicgames.marketo.reset" />}
            </SecondaryButton>

            <div className="privacy-link">
                <a href={`https://www.epicgames.com/privacypolicy?lang=${getLocale()}`} target="_blank" rel="noopener noreferrer">
                    <Message code="epic.footer.privacy_policy" />
                </a>
            </div>

            {loading ? (
                <div className="loadingWrap">
                    {loadingNode ? loadingNode : <Loading src={loadingImg || loadingGif} />}
                </div>
            ) : (
                ''
            )}

            <div className="successWrap">
                {submitted && success ? (
                    <h3>
                        {/*eslint-disable-next-line react/no-danger */}
                        {successMsg ? <div dangerouslySetInnerHTML={{__html: successMsg}} /> : <Message code="com.epicgames.marketo.submit.success" />} 
                    </h3>
                ) : (
                    ''
                )}
                {submitted && !success ? (
                    <h3 className="error">
                        {failMsg}
                        {errors.length ? errors.map(err => {
                            if (typeof err === 'string') {
                                return <p key={err}>{err}</p>;
                            }
                            if (err && err.code && err.message) {
                                return <p key={err.code}>{err.message}</p>;
                            } else if (err && err.message) {
                                return <p key={err.message}>{err.message}</p>;
                            }
                            return '';
                        }) : ''}
                    </h3>
                ) : (
                    ''
                )}
            </div>
        </ButtonWrap>
    );
};

MarketoButtonToolbar.propTypes = {
    loading: pt.bool,
    pristine: pt.bool,
    success: pt.bool,
    formValid: pt.bool,
    reset: pt.func,
    submitted: pt.bool,
    status: pt.number,
    successBtnLabel: pt.oneOfType([pt.string, pt.object]),
    resetBtnLabel: pt.oneOfType([pt.string, pt.object]),
    failureMsg: pt.oneOfType([pt.string, pt.object]),
    successMsg: pt.oneOfType([pt.string, pt.object]),
    loadingImg: pt.string,
    loadingNode: pt.node,
    errors: pt.array,
    errorCode: pt.string,
    submissionDisclaimer: pt.any
};

export default MarketoButtonToolbar;
